import $ from 'jquery';

$('.lazyload--bg').each(function () {
    $(this).css('background-image', $(this).attr('data-css-background-image'));
});
